/* eslint-disable */
import {
    BASIC_COMPOSITION_TYPE,
    FREE_AMOUNT_ON_ORDER,
    PERCENT_ON_ORDER,
} from "@constants";

export function isTotalPriceValid(
    orderItems: OrderItem[],
    totalOrder: number,
    usedGifts: any[]
): boolean {
    const isOrderItemHaveDiscount = orderItems.some(
        (item) => item.isReward || item.isPromo || item.isOfferParent
    );
    const isTotalGiftsDiscount = usedGifts.some(
        (item) =>
            parseFloat(item.discountType) === PERCENT_ON_ORDER ||
            parseFloat(item.discountType) === FREE_AMOUNT_ON_ORDER
    );

    //* If any item has a promo, reward, or offer light. Consider the total price valid
    if (isOrderItemHaveDiscount || isTotalGiftsDiscount) {
        console.log(
            "Total price validation bypassed due to discount item (reward, promo, offer light)."
        );
        return true;
    }

    orderItems = orderItems.reduce((prev: any, currProd) => {
        if (currProd.quantity > 1) {
            const separatedProducts = [];
            for (let i = 0; i < currProd.quantity; i++) {
                const itemData = {
                    ...currProd,
                    quantity: 1,
                };
                separatedProducts.push(itemData);
            }
            return [...prev, ...separatedProducts];
        }
        return [...prev, currProd];
    }, []);
    const totalShopCartPrice = orderItems.reduce((total, item: OrderItem) => {
        const shopCart = item.shopCart || {};
        const initialPrice = item?.initialPrice || 0;
        const itemTotal = Object.values(shopCart).reduce((stepTotal, step) => {
            const compositions = step.compositions || {};
            const compositionTotal = Object.values(compositions).reduce(
                (compTotal: any, comp: any) => {
                    const quantity = comp.quantity ?? 1;
                    const price = comp.price ?? 0;
                    const subCompositions = comp.compositions || {};

                    let nestedTotal = 0;
                    if (
                        subCompositions &&
                        typeof subCompositions === "object"
                    ) {
                        nestedTotal = calculateItemTotal(subCompositions);
                    }

                    return compTotal + price * quantity + nestedTotal;
                },
                0
            );
            return stepTotal + compositionTotal;
        }, initialPrice);
        return total + itemTotal;
    }, 0);

    console.log(
        `Total price validation: Total shop cart price: ${totalShopCartPrice.toFixed(
            2
        )}, Total order: ${totalOrder.toFixed(2)}`
    );
    return totalShopCartPrice.toFixed(2) == totalOrder.toFixed(2);
}

function calculateItemTotal(compositions: Record<string, any>): number {
    return Object.values(compositions)
        .filter((composition) => composition.type !== BASIC_COMPOSITION_TYPE)
        .reduce((compTotal, curComposition) => {
            const quantity = curComposition.quantity ?? 1;
            const price = curComposition.price ?? 0;

            if (
                curComposition.compositions &&
                typeof curComposition.compositions === "object"
            ) {
                compTotal += calculateItemTotal(curComposition.compositions);
            }

            return compTotal + price * quantity;
        }, 0);
}
